// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"zY-z","subtitle":"AY-z","wrapper":"BY-z","leftArrow":"CY-z","rightArrow":"DY-z"};